/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as emotion from "emotion";
import {Spacing} from "@styles/styles";
import * as React from "react";
import {CSSProperties} from "react";
import {CARD_BORDER_RADIUS} from "./Card";

export const cardHeaderStyle = emotion.css(
	{
		justifyContent: 'space-between',
		height: 0, // used as horizontal axis to vertically center items
		paddingTop: '35px',
		paddingLeft: Spacing.l,
		paddingRight: Spacing.l,
		paddingBottom: Spacing.m,
		borderRadius: `${CARD_BORDER_RADIUS} ${CARD_BORDER_RADIUS} 0px 0px`
	});

type Props = { className?: string, style?: CSSProperties, children: React.ReactNode, onClick?: () => void };
export class CardHeader
	extends React.Component<Props> {

	constructor(props: Props) {
		super(props);
	}

	render() {
		return <div className={`ll_h_c ${cardHeaderStyle} ${this.props.className ? `${this.props.className}` : ''}`}
		            style={{...this.props.style}}
		            onClick={() => this.props.onClick?.()}>
			{this.props.children}
		</div>;
	}
}
